import React from 'react'
import { Dropdown, Form } from 'semantic-ui-react'

export default function CompanyInformationForm({
  selectedItems,
  industryOptions,
  companySizeOptions,
  countryOptions,
  setSelectItems,
}) {
  const getSelectedByType = (type) => selectedItems.find((obj) => obj.type === type)

  const selectedIndustry = getSelectedByType('industry')
  const selectedSize = getSelectedByType('size')
  const selectedCountry = getSelectedByType('country')

  function handelSelectDropdown(newItemId, type) {
    let optionData = []
    if (type == 'industry') {
      optionData = industryOptions
    } else if (type == 'size') {
      optionData = companySizeOptions
    } else if (type == 'country') {
      optionData = countryOptions
    }

    const newSelectedItem = optionData
      .filter((obj) => obj.id === newItemId) // Filter the matching object
      .map((obj) => ({ ...obj, type }))[0] // override type

    // Remove any existing item with the same type
    const updatedData = selectedItems.filter((item) => item.type !== newSelectedItem.type)

    // Add the new one
    const newList = [...updatedData, newSelectedItem]

    // Define the priority order
    const priority = ['industry', 'size', 'country']

    // Sort the list with priority first, then others
    const sortedList = [
      ...priority.map((key) => newList.find((item) => item.type === key)).filter(Boolean), // remove undefined
      ...newList.filter((item) => !priority.includes(item.type)),
    ]

    setSelectItems(sortedList)
  }

  return (
    <>
      <Form.Field>
        <label>Industry</label>
        <Dropdown
          key="selectedIndustry"
          placeholder="Select industry"
          onChange={(_, data) => handelSelectDropdown(data.value, 'industry')}
          selection
          compact
          options={industryOptions.map((item) => ({
            key: item.id,
            text: item.name,
            value: item.id,
          }))}
          value={selectedIndustry?.id}
        />
      </Form.Field>
      <Form.Field>
        <label>Company size</label>
        <Dropdown
          key="selectedCompanySize"
          placeholder="Select company size"
          onChange={(_, data) => handelSelectDropdown(data.value, 'size')}
          selection
          compact
          options={companySizeOptions.map((item) => ({
            key: item.id,
            text: item.name,
            value: item.id,
          }))}
          value={selectedSize?.id}
        />
      </Form.Field>
      <Form.Field>
        <label>Country</label>
        <Dropdown
          key="selectCountry"
          onChange={(_, data) => handelSelectDropdown(data.value, 'country')}
          selection
          compact
          placeholder="Select country"
          search
          options={countryOptions.map((item) => ({
            key: item.id,
            text: item.name,
            value: item.id,
          }))}
          value={selectedCountry?.id}
        />
      </Form.Field>
    </>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CompanyInformationForm/index.js